export default __webpack_public_path__ + "static/media/confirmed.97c4bffd.png";